import { functions } from '~/firebase'

export const confirmVerifiedOrder = functions.httpsCallable('confirmVerifiedOrder')
export const getUser = functions.httpsCallable('getUser')
export const logUser = functions.httpsCallable('logUser')



// WEBPACK FOOTER //
// ./src/firebase.functions.ts